export default {
  setCourses (state, payload) {
    state.list = payload
  }
}